import React, {Component, ReactElement, ReactNode} from 'react'
import {AdminPagePropsSet} from '../../../../components/shared/hoc/createAdminPage'
import {
    LightGrayTableHeadColor,
    StyledTableCaption,
    TableRowNameTop
} from '../../../../styledComponents/adminPage/Table'
import {Box, Table, TableBody, TableRow, TableCell, TableHead} from '@mui/material'
import EventEmitterExAdmin from '../../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import withStyles from '@mui/styles/withStyles'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea
} from '../../../../components/shared/hoc/withAdminPageTemplate'
import {AdminDefaultMediumButton, AdminPrimaryButton} from '../../../../styledComponents/adminPage/Buttons'
import {BackLink} from '../../../../styledComponents/adminPage/Links'
import {DISASTER_MODE, SELECT_CONDOMINIUM_TYPE, USE_FUNCTION_ID} from '../../../../CodeMaster'
import {CondominiumInfo} from '../../condominium/repository/NatGetCondominiumList'
import styled from 'styled-components'
import {Colors} from '../../../../styledComponents/Constants'
import NatCondominiumSelectionComponent from '../../common/admin/NatCondominiumSelectionComponent'
import NatCondominiumGroupRepo from '../../condominiumGroup/repository/NatCondominiumGroupRepo'
import NatCondominiumRepo from '../../condominium/repository/NatCondominiumRepo'
import {AsyncCallFunctionType} from '../../../../components/shared/hoc/withAsyncCommunication'
import NatAdminCommonAcceptedWarningComponent from '../../common/admin/NatAdminCommonAcceptedWarningComponent'
import {Messages} from '../../../../Messages'
import {AcceptedWarning, Warning} from '../../common/admin/NatAcceptedWarning'
import {HKConstants} from '../../../../HKConstants'
import {Location, NavigateFunction} from 'react-router-dom'
import NatAdminDisasterCondominiumRecode from './NatAdminDisasterCondominiumRecode'

interface Props {
    mode: 'setting' | 'release'
    disasterModeEnableButtonText: string
    onDisasterModeSetting: (condominiumList: CondominiumInfo[]) => Promise<void>
    condominiumGroupRepo: NatCondominiumGroupRepo
    condominiumRepo: NatCondominiumRepo
    eventEmitter: EventEmitterExAdmin
    asyncCallFunction: AsyncCallFunctionType
    navigate: NavigateFunction
    location: Location
}

interface States {
    selectedCondominiumList: CondominiumInfo[]
    warningList: Warning[]
    isAcceptedAllWarning: boolean
    isOpenSelectCondominiumDialog: boolean
    isDisabledButton: boolean
}

interface Column {
    label: string;
    width?: number;
}

const headerColumns: Column[] = [
    {label: '物件コード', width: 120},
    {label: '物件名', width: 360},
    {label: '物件グループ', width: 220},
    {label: '都道府県', width: 110},
    {label: '市区町村', width: 220},
    {label: ''}
]

export class NatAdminDisasterModeSettingForm extends Component<Props, States> {
    constructor(props: Props & AdminPagePropsSet) {
        super(props)
        this.state = {
            selectedCondominiumList: [],
            warningList: [],
            isAcceptedAllWarning: false,
            isOpenSelectCondominiumDialog: false,
            isDisabledButton: true
        }
    }

    handleSelectCondominiumButtonClick = () => {
        this.setState({isOpenSelectCondominiumDialog: true})
    }

    handleCloseCondominiumDialog = () => {
        this.setState({isOpenSelectCondominiumDialog: false})
    }

    handleSelectCondominium = (selectedCondominiumList: CondominiumInfo[]) => {
        this.setState({
            isOpenSelectCondominiumDialog: false,
            selectedCondominiumList: selectedCondominiumList.sort((a, b) =>
                Number(a.condominiumCd) - Number(b.condominiumCd))
        }, () => {
            this.updateSettingButtonDisabled()
        })
    }

    handleDeleteCondominium = (condominiumCd: string) => {
        const {selectedCondominiumList} = this.state

        this.setState({
            selectedCondominiumList:
                selectedCondominiumList.filter(condominium => condominium.condominiumCd !== condominiumCd)
        }, () => {
            this.updateSettingButtonDisabled()
        })
    }

    handleChangeWarning = (acceptAll: boolean, acceptedWarning: AcceptedWarning[]) => {
        this.setState({
            isAcceptedAllWarning: acceptAll
        }, () => {
            this.updateSettingButtonDisabled()
        })
    }

    handleDisasterModeEnable = async (): Promise<void> => {
        const {mode} = this.props
        const {isAcceptedAllWarning, selectedCondominiumList} = this.state

        if (isAcceptedAllWarning) {
            await this.props.onDisasterModeSetting(selectedCondominiumList)
            return
        }

        const warningList: Warning[] = []
        if (mode === 'setting') {
            warningList.push({messageId: 'WDISA0001', message: Messages.WDISA0001.toString('設定')})
            warningList.push({messageId: 'WDISA0002', message: Messages.WDISA0002.toString()})
        } else {
            warningList.push({messageId: 'WDISA0001', message: Messages.WDISA0001.toString('解除')})
        }
        this.setState({
            warningList: warningList,
            isDisabledButton: true
        })
    }

    updateSettingButtonDisabled = () => {
        const {selectedCondominiumList, warningList, isAcceptedAllWarning} = this.state
        if (warningList.length === 0) {
            this.setState({isDisabledButton: selectedCondominiumList.length === 0})
        } else {
            this.setState({isDisabledButton: selectedCondominiumList.length === 0 || !isAcceptedAllWarning})
        }
    }

    renderInputFormTable(): ReactNode {
        const {selectedCondominiumList} = this.state

        return (
            <Table>
                <StyledTableCaption>設定内容</StyledTableCaption>
                <TableBody>
                    <TableRow>
                        <TableRowNameTop required>対象物件</TableRowNameTop>
                        <TableCell>
                            <AdminDefaultMediumButton onClick={this.handleSelectCondominiumButtonClick}>
                                物件を選択
                            </AdminDefaultMediumButton>
                            <Box mt={'16px'} mb={'8px'} fontWeight={'bold'}>
                                選択中の物件({selectedCondominiumList.length})
                            </Box>
                            <CondominiumTableArea>
                                <Table stickyHeader size={'small'}>
                                    <TableHead>
                                        <TableRow>
                                            {headerColumns.map(
                                                (headerColumn, index) =>
                                                    <TableHeaderCell
                                                        key={index}
                                                        style={{width: headerColumn.width}}
                                                    >
                                                        {headerColumn.label}
                                                    </TableHeaderCell>
                                            )}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {selectedCondominiumList.map((condominium) =>
                                            this.renderCondominiumTableRow(condominium))}
                                    </TableBody>
                                </Table>
                                {selectedCondominiumList.length === 0 &&
                                    <TableTextArea>
                                        選択した物件が表示されます。
                                    </TableTextArea>
                                }
                            </CondominiumTableArea>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        )
    }

    renderCondominiumTableRow(condominium: CondominiumInfo): ReactElement {
        const {condominiumCd} = condominium

        return <NatAdminDisasterCondominiumRecode
            key={condominiumCd}
            condominium={condominium}
            onClickDeleteCondominium={this.handleDeleteCondominium}
        />
    }

    renderPageFooterArea(): ReactNode {
        const {disasterModeEnableButtonText} = this.props
        const {isDisabledButton} = this.state

        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton
                        disabled={isDisabledButton}
                        onClick={this.handleDisasterModeEnable}
                    >
                        {disasterModeEnableButtonText}
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink onClick={() => this.props.navigate('/admin/disasters/mode/statuses')}>
                        モード設定状況一覧へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }


    render(): ReactElement {
        return (
            <>
                <PageMainArea>
                    {this.renderInputFormTable()}
                </PageMainArea>
                {this.state.warningList.length > 0 &&
                    <>
                        <Box height={'16px'}/>
                        <NatAdminCommonAcceptedWarningComponent
                            description={this.props.mode === 'setting' ?
                                '内容をご確認いただき、問題なければチェックしたうえで設定するボタンを押してください。'
                                :
                                '内容をご確認いただき、問題なければチェックしたうえで解除するボタンを押してください。'}
                            warnings={this.state.warningList}
                            changeAcceptedWarnings={this.handleChangeWarning}
                            doOpenAnimation={true}
                        />
                    </>
                }
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
                {this.state.isOpenSelectCondominiumDialog &&
                    <NatCondominiumSelectionComponent
                        selectCondominiumType={SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value}
                        condominiumRepo={this.props.condominiumRepo}
                        condominiumGroupRepo={this.props.condominiumGroupRepo}
                        closeSelectCondominiumDiaLog={this.handleCloseCondominiumDialog}
                        setSelectedExclusionCondominiumInfo={this.handleSelectCondominium}
                        selectedCondominiumGroupId={HKConstants.VMN.COG.HASEKO_HOLDINGS_CONDOMINIUM_GROUP_ID}
                        eventEmitter={this.props.eventEmitter}
                        navigate={this.props.navigate}
                        location={this.props.location}
                        asyncCallFunction={this.props.asyncCallFunction}
                        excludeCondominium={this.state.selectedCondominiumList}
                        useFunctionId={USE_FUNCTION_ID.DISASTER}
                        rootCondominiumGroupId={HKConstants.VMN.COG.HASEKO_HOLDINGS_CONDOMINIUM_GROUP_ID}
                        disasterModeStatus={this.props.mode === 'setting' ? DISASTER_MODE.OFF : DISASTER_MODE.ON}
                    />}
            </>
        )
    }
}

const CondominiumTableArea = styled.div`
    height: 342px;
    margin-right: 17px;
    overflow: auto;
    border: ${Colors.AccentLight} solid 1px;
    white-space: nowrap;
    word-break: keep-all;

    .MuiTableCell-stickyHeader {
        left: unset;
    }
`

const TableHeaderCell = withStyles({
    root: {
        backgroundColor: LightGrayTableHeadColor,
        lineHeight: '20px',
        height: '49px',
        padding: '0 12px',
        border: 'none'
    }
})(TableCell)

const TableTextArea = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 80%;
    justify-content: center;
`